import { useAuth } from 'contexts/auth';
import InstructorViewSubmissionPage from 'pages/InstructorViewSubmission';
import StudentViewSubmissionPage from 'pages/StudentViewSubmission';

const ViewSubmissionPage = () => {
    const { auth } = useAuth();
    if (auth.role === 'instructor') return <InstructorViewSubmissionPage />;
    if (auth.role === 'ta') return <InstructorViewSubmissionPage />;
    if (auth.role === 'student') return <StudentViewSubmissionPage />;
    return null;
};

export default ViewSubmissionPage;
